<template>
    <v-container fluid>
        <v-card outlined class="flex-column">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(onSubmit(currentCarrier, carrier ? 'update' : 'add'))">
                    <v-card outlined class="mx-auto my-8 pa-1">
                        <v-container>
                            <ValidationProvider rules="required" name="name" v-slot="{ errors }">
                                <v-text-field v-model="currentCarrier.name" type="string" label="Nom"
                                    :error-messages="errors">
                                </v-text-field>
                            </ValidationProvider>
                            <ValidationProvider rules="required" name="enabled" v-slot="{ errors }">
                                <v-checkbox v-model="currentCarrier.enabled" label="Activé"
                                    :error-messages="errors"></v-checkbox>
                            </ValidationProvider>
                            <v-card outlined class="mx-auto my-6 pa-3">
                                <div class="d-flex justify-space-between align-end">
                                    <div>Zone de livraison</div>
                                </div>
                                <ValidationProvider rules="required" name="restrictions" v-slot="{ errors }">
                                    <v-switch v-model="currentCarrier.delivery_zone.enabled" :error-messages="errors"
                                        label="Restrictions"></v-switch>
                                </ValidationProvider>
                                <Restrictions v-if="currentCarrier.delivery_zone.enabled" :restrictions="currentCarrier.delivery_zone.restrictions" @addRestriction="addRestriction($event)" @removeRestriction="removeRestriction($event)" />
                            </v-card>
                            <v-select v-model="currentCarrier.location_restriction" multiple
                                :items="['Entrepot', 'Magasin', 'Fournisseur']" label="Restrictions à l'emplacement"
                                class="d-flex justify-center align-center py-2" dense hide-details="auto" outlined>
                            </v-select>
                        </v-container>
                    </v-card>
                    <v-row class="justify-center pb-7">
                        <v-btn class="ma-2"
                            color="primary" outlined type="submit">{{
                                carrier? 'Mettre à jour'
                                    : 'Créer'
                            }}</v-btn>
                        <v-btn v-if="carrier" @click="onDelete(currentCarrier.id)" class="ma-2" color="primary"
                            outlined>Supprimer</v-btn>
                    </v-row>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-container>
</template>
  
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Restrictions from '../../components/carriers/deliveryMethods/eligibility/CountriesEligibility.vue'

export default {
    name: "CarriersDetails",
    components: {
        ValidationProvider,
        ValidationObserver,
        Restrictions
    },
    props: {
        carrier: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            currentCarrier: {
                name: '',
                enabled: true,
                delivery_zone: {
                    enabled: false,
                    restrictions: []
                },
                location_restriction: []
            }
        };
    },
    mounted() {
        if (this.carrier) {
            this.currentCarrier = this.carrier
        }
    },
    methods: {
        onSubmit(currentCarrier, action) {
            if (action === 'add') {
                const carrierWithId = currentCarrier
                carrierWithId.id = this.$store.state.carriersTemp.length + 1
                this.$store.state.carriersTemp.push(
                    carrierWithId
                )
            }
            if (action === 'update') {
                this.$store.state.carriersTemp[this.$store.state.carriersTemp.map((x) => { return x.id; }).indexOf(currentCarrier.id)] = currentCarrier
            }
            this.$router.push({
                name: 'carriers'
            });
        },
        onDelete(carrierId) {
            this.$store.state.carriersTemp.splice(this.$store.state.carriersTemp.map((x) => { return x.id; }).indexOf(carrierId), 1)
            this.$router.push({
                name: 'carriers'
            });
        },
        addRestriction(restrictions) {
            this.currentCarrier.delivery_zone.restrictions.push({ source:restrictions.source, destinations:restrictions.destinations, id: this.currentCarrier.delivery_zone.restrictions.length + 1 })
        },
        removeRestriction(id) {
            this.currentCarrier.delivery_zone.restrictions = this.currentCarrier.delivery_zone.restrictions.filter(restriction => restriction.id !== id);
        },
    },
};
</script>
  
<style scoped>
.card-title {
    word-break: normal !important;
}

.row-appointment-default {
    display: flex;
    align-items: baseline;
    margin: 15px 0;
}

#cancel-service {
    cursor: pointer;
}
</style>
